<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="200px">
      <el-form-item label="活动名称：" prop="activityName" class="width100">
        <el-input v-model="form.activityName" placeholder="请输入活动名称"></el-input>
      </el-form-item>
      <el-form-item label="套餐金额：" prop="rechargeMoney" class="width100">
        <el-input v-model="form.rechargeMoney" placeholder="请输入套餐金额(充值多少得相应的余额)">
          <span slot="suffix" style="margin-right: 5px;">元</span>
        </el-input>
      </el-form-item>
      <el-form-item label="奖励：" prop="rewardType" class="width100">
        <div class="reward-type">
          <el-select v-model="form.rewardType" placeholder="请选择奖励类型" clearable size="mini">
            <el-option label="商品" :value="1"></el-option>
            <el-option label="零售价" :value="2"></el-option>
          </el-select>
          <el-cascader v-model="form.goodsSelect" filterable :options="goodsList" placeholder="请选择商品及规格" clearable v-if="form.rewardType==1" @expand-change="handleExpandChange" @change="handleGoodsChange"/>
          <!-- <el-select v-model="form.goodsId" filterable placeholder="请选择商品" clearable size="mini" v-if="form.rewardType==1">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in goodsList" :key="index"></el-option>
          </el-select> -->
          <el-input v-model="form.xiaoduMoney" placeholder="请输入零售价" v-else-if="form.rewardType==2"></el-input>
          <el-select disabled placeholder="请选择奖励" clearable size="mini" v-else></el-select>
        </div>
      </el-form-item>
      <el-form-item label="参与身份：" prop="participationType" class="width100">
        <el-checkbox-group v-model="form.participationType">
          <el-checkbox label="7" >体验班</el-checkbox>
          <el-checkbox label="6">研修班</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="是否限制时间：" prop="isLimit" class="width100">
        <el-radio-group v-model="form.isLimit" @input="changeLimit">
          <el-radio :label="false">不限制</el-radio>
          <el-radio :label="true">限制</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="套餐上下架时间：" prop="times" class="width100" v-if="form.isLimit">
        <el-date-picker v-model="form.times" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="大区分润比例(体验班)：" prop="experienceRatio">
        <el-input v-model="form.experienceRatio" placeholder="请输入分润比例">
          <span slot="suffix" style="margin-right: 5px;">%</span>
        </el-input>
      </el-form-item>
      <el-form-item label="大区分润比例(研修班)：" prop="trainingRatio">
        <el-input v-model="form.trainingRatio" placeholder="请输入分润比例">
          <span slot="suffix" style="margin-right: 5px;">%</span>
        </el-input>
      </el-form-item>
      <el-form-item label="活动类型：" prop="activityType" class="width100">
        <el-radio-group v-model="form.activityType" @change="handleActivityTypeChange">
          <el-radio :label="0">常规充值</el-radio>
          <el-radio :label="1">直播充值</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="充值类型：" prop="rechargeType" class="width100">
        <el-select v-model="form.rechargeType" placeholder="请选择充值类型" clearable size="small">
          <el-option 
            v-for="(item, index) in rechargeTypeOptions" 
            :key="index" 
            :label="item" 
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主图(76*76)：" prop="mainImg" class="width100" v-if="form.activityType === 1">
        <ImageUpload v-model="form.mainImg" :limit="1" />
      </el-form-item>
      <el-form-item label="Banner图(375*375)：" prop="bannerImg" class="width100" v-if="form.activityType === 1">
        <MoreImageUpload v-model="form.bannerImg" :limit="6" />
        <div style="font-size: 12px; color: #999; margin-top: 5px;">
          最多上传6张图片，多张图片以英文逗号分隔
        </div>
      </el-form-item>
      <el-form-item label="活动详情：" prop="detail" class="width100" v-if="form.activityType === 1">
        <Editor v-model="form.detail" :min-height="300" />
      </el-form-item>
      <el-form-item label="状态：" prop="state" class="width100">
        <el-switch v-model="form.state" :active-text="form.state?'上架':'下架'"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import rechargeActivityApi from '@/api/recharge/rechargeActivity'
  import sysGoodsApi from '@/api/goods/sysGoods'
  import sysDataconstantApi from '@/api/config/sysDataconstant'
import { dateTime } from '@/utils/dateTime'
import Editor from '@/components/Editor'
import ImageUpload from '@/components/ImageUpload'
import MoreImageUpload from '@/components/MoreImageUpload'

  function initFormBean() {
    const formBean = {
      activityName: '',
      rechargeMoney: '',
      rewardType: '',
      isLimit: false,
      participationType:[],
      state: true,
      trainingRatio: '',
      experienceRatio: '',
      endTime: '',
      startTime: '',
      times: '',
      xiaoduMoney: '',
      goodsId: '',
      skuId: '',
      goodsSelect: [],
      detail: '', // 活动详情富文本
      activityType: 0, // 活动类型 0常规充值 1直播充值
      rechargeType: '', // 充值类型
      mainImg: '', // 主图
      bannerImg: [] // Banner图数组
    }
    return formBean
  }

  export default {
    components: {
      Editor,
      ImageUpload,
      MoreImageUpload
    },
    props: ['popType'],
    //popType 0:新增 1:编辑
    data() {
      return {
       
        titleList: ['添加充值套餐', '编辑充值套餐'],
        form: initFormBean(),
        formVisible: false,
        formRules: {
          activityName: [{
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          }],
          rechargeMoney: [{
            required: true,
            message: '请输入套餐金额',
            trigger: 'blur'
          }, {
            pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/,
            message: '请输入正确的金额'
          }],
          isLimit: [{
            required: true,
            message: '请选择是否限制时间',
            trigger: 'change'
          }],
          participationType:[{
            required: true,
            message: '请选择参与身份',
            trigger: 'change'
          }],
          trainingRatio: [{
            required: true,
            message: '请输入分润比例(研修班)',
            trigger: 'blur'
          }, {
            pattern: /^(\d+(\.\d+)?|\.\d+)$/,
            message: '请输入正确的比例'
          }],
          experienceRatio: [{
            required: true,
            message: '请输入分润比例(体验班)',
            trigger: 'blur'
          }, {
            pattern: /^(\d+(\.\d+)?|\.\d+)$/,
            message: '请输入正确的比例'
          }],
          // 直播充值时的必填字段验证
          mainImg: [{
            required: true,
            message: '请上传主图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.form.activityType === 1 && !value) {
                callback(new Error('直播充值活动必须上传主图'));
              } else {
                callback();
              }
            }
          }],
          bannerImg: [{
            required: true,
            message: '请上传Banner图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.form.activityType === 1 && (!value || value.length === 0)) {
                callback(new Error('直播充值活动必须上传Banner图'));
              } else {
                callback();
              }
            }
          }],
          detail: [{
            required: true,
            message: '请填写活动详情',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.form.activityType === 1 && (!value || value.trim() === '')) {
                callback(new Error('直播充值活动必须填写活动详情'));
              } else {
                callback();
              }
            }
          }],
          rechargeType: [{
            required: true,
            message: '请选择充值类型',
            trigger: 'change'
          }]
        },
        goodsList: [],
        rechargeTypeOptions: [], // 充值类型选项
        query: {
          pageNo: 1,
          pageSize: 100
        }
      }
    },
    created() {
      this.getGoodsList();
      this.getRechargeTypeOptions();
    },
    methods: {
      /**
       * 处理商品选择变化
       */
      handleGoodsChange(value) {
        if (value && value.length === 2) {
          this.form.goodsId = value[0];
          // 去掉skuId中的_a后缀
          this.form.skuId = +(value[1].replace('_a', ''));
        } else {
          this.form.goodsId = '';
          this.form.skuId = '';
        }
      },
      handleExpandChange(val) {
        if (val && val.length === 1) {
          const parent = this.goodsList.find(item => item.value === val[0])
          if (parent && parent.children && parent.children.length === 1) {
            this.form.goodsSelect = [val[0], parent.children[0].value]
          }
        }
      },
      /**
       * 获取充值类型选项
       */
      getRechargeTypeOptions() {
        sysDataconstantApi.fetchBatchCode({ code: 'chongZhiLeiXingPeiZhi' })
          .then(({ data }) => {
            const find = data.list.find(item => item.code === 'chongZhiLeiXingPeiZhi')
            if (find && find.content) {
              this.rechargeTypeOptions = find.content.split(',').filter(item => item.trim())
            }
          })
      },
      /**
       * 获取商品列表
       */
      getGoodsList() {
        let params = {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          areaIdList: '3,4,5',
          state: 1
        }
        sysGoodsApi.fetchList(params).then((data) => {
          if (this.pageNo == 1) this.goodsList = [];
          this.goodsList = this.goodsList.concat(data.data.list);
          setTimeout(() => {
            if (data.data.total > this.goodsList.length) {
              this.query.pageNo++;
              this.getGoodsList();
            }else{
              this.goodsList = this.goodsList.map(item => ({
                label: item.name,
                value: item.id,
                children: item.skuList && item.skuList.map(spec => ({
                  label: spec.spec || '无规格值',
                  value: spec.id + '_a'
                }))
              }))
            }
          }, 1000)
        });
      },
      /**
       * 选择是否限制时间
       */
      changeLimit(event) {
        if (event) {
          this.formRules.times = [{
            required: true,
            message: '请选择上下架时间',
            trigger: 'change'
          }];
        } else {
          this.formRules.times = [{
            required: false,
            message: '请选择上下架时间',
            trigger: 'change'
          }];
          this.form.times = ''
        }
      },
      /**
       * 监听活动类型变化
       */
      handleActivityTypeChange() {
        if (this.form.activityType === 1) {
          // 切换到直播充值时，重新验证相关字段
          this.$nextTick(() => {
            this.$refs['dataForm'].validateField(['mainImg', 'bannerImg', 'detail']);
          });
        } else {
          // 切换到常规充值时，清空相关字段数据
          this.form.mainImg = '';
          this.form.bannerImg = [];
          this.form.detail = '';
          // 清除相关字段的验证错误
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate(['mainImg', 'bannerImg', 'detail']);
          });
        }
      },
      /**
       * 重置表单
       */
      resetForm() {
        this.form.pageNo = 1
        this.form = initFormBean()
      },
      /**
       * 打开新建表单
       */
      handleCreate() {
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      /**
       * 打开编辑表单
       */
      handleUpdate(data) {
        this.resetForm()
        this.form = {
          ...data.row
        }
        console.log('this.form: ',this.form);
        if(this.form.participationType && this.form.participationType.length){
          this.form.participationType=this.form.participationType.split(',')
        }else{
          this.form.participationType=[]
        }
        if (this.form.rewardType == 3) this.form.rewardType = '';
        
        // 处理商品选择回显
        if (this.form.goodsId && this.form.skuId) {
          this.form.goodsSelect = [this.form.goodsId, this.form.skuId + '_a'];
        }
        
        // 处理Banner图片回显：将逗号分隔的字符串转换为数组
        if (this.form.bannerImg && typeof this.form.bannerImg === 'string') {
          this.form.bannerImg = this.form.bannerImg.split(',').filter(url => url.trim()).map(url => ({
            url: url.trim(),
            name: url.trim().split('/').pop() || 'image'
          }))
        } else if (!this.form.bannerImg) {
          this.form.bannerImg = []
        }
        
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      /**
       * 提交表单
       */
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            if (this.form.isLimit) {
              // 限制时间：使用用户选择的时间
              this.form.startTime = this.form.times[0];
              this.form.endTime = this.form.times[1];
            } else {
              // 不限制时间的情况
              if (this.form.id > 0) {
                // 编辑活动
                this.form.startTime = this.form.startTime || this.getCurrentTime();
                if (this.form.state) {
                  // 活动开启：当前时间加100年
                  this.form.endTime = this.getTimeAfterYears(100);
                } else {
                  // 活动下架：当前时间
                  this.form.endTime = this.getCurrentTime();
                }
              } else {
                // 新增活动
                this.form.startTime = this.getCurrentTime();
                this.form.endTime = this.getTimeAfterYears(100);
              }
            }
            if (this.form.rewardType == 1) {
              this.form.xiaoduMoney = null;
            } else if (this.form.rewardType == 2) {
              this.form.goodsId = null;
              this.form.skuId = null;
            } else {
              this.form.xiaoduMoney = this.form.goodsId = this.form.skuId = null;
            }
            let params = JSON.parse(JSON.stringify(this.form))
            delete params.goodsSelect
            params.participationType=params.participationType.join(',')
            if (this.form.rewardType == '') params.rewardType = 3;
            
            // 处理Banner图片数组转换为逗号分隔的字符串
            if (this.form.bannerImg && Array.isArray(this.form.bannerImg)) {
              params.bannerImg = this.form.bannerImg.map(img => img.url).join(',')
            }
            if (this.form.id > 0) {
              rechargeActivityApi.update(params).then((data) => {
                this.postCallback(data)
              });
            } else {
              rechargeActivityApi.create(params).then((data) => {
                this.postCallback(data)
              });
            }
          }
        });
      },
      /**
       * 回调
       */
      postCallback(response) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
      },
      /**
       * 获取当前时间字符串
       */
      getCurrentTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      /**
       * 获取指定年数后的时间字符串
       */
      getTimeAfterYears(years) {
        const now = new Date();
        const futureDate = new Date(now.getFullYear() + years, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, '0');
        const day = String(futureDate.getDate()).padStart(2, '0');
        const hours = String(futureDate.getHours()).padStart(2, '0');
        const minutes = String(futureDate.getMinutes()).padStart(2, '0');
        const seconds = String(futureDate.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
    }
  }
</script>
<style lang="scss" scoped>
  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .reward-type {
    display: flex;

    &>.el-select {
      &:first-child {
        width: 180px;
        margin-right: 10px;
      }
    }
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-cascader {
    width: 100%;
  }
</style>
